// Importar los pages
// Este archivo de rutas, debe ser dinámico e incremental

import Layout from "../../layouts/Layout";
import Page1 from "../../pages/page1/Page1";
import Page2 from "../../pages/page2/Page2";
import ParqueGasometros from "../../pages/gasometros/Gasometros";
import QuienesSomos from "../../pages/quienes-somos/QuienesSomos";
import Proyecto from "../../pages/proyecto/Proyecto";
import NuestraHistoria from "../../pages/nuestra-historia/NuestraHistoria";
import CasaAbierta from "../../pages/casa-abierta/CasaAbierta";
import NuestroParque from "../../pages/nuestro-parque/NuestroParque";
import Noticias from "../../pages/noticias/Noticias";
import NoticiaRouteHandler from "../../pages/noticias/NoticiaRouteHandler"; 

const title: string = '';
const breadTitle: string = '';


const routesPages = [
  {
    path: '/',
    title: 'Gasómetros | Empresas GASCO',
    breadTitle: 'Crear ' + breadTitle,
    layout: Layout, 
    component: ParqueGasometros,
  },
  {
    path: '/',
    title: title,
    breadTitle: 'Crear ' + breadTitle,
    layout: Layout,
    component: Page1,
  },
  {
    path: '/quienes-somos',
    title: 'Quiénes Somos | Empresas GASCO',
    breadTitle: 'Quiénes Somos',
    layout: Layout,
    component: QuienesSomos,
  },
  {
    path: '/proyecto',
    title: 'Proyecto | Empresas GASCO',
    breadTitle: 'Proyecto',
    layout: Layout,
    component: Proyecto,
  },
  {
    path: '/nuestra-historia',
    title: 'Nuestra Historia | Empresas GASCO',
    breadTitle: 'Nuestra Historia',
    layout: Layout,
    component: NuestraHistoria,
  },
  {
    path: '/casa-abierta',
    title: 'Casa Abierta | Empresas GASCO',
    breadTitle: 'Casa Abierta',
    layout: Layout,
    component: CasaAbierta,
  },
  {
    path: '/nuestro-parque',
    title: 'Nuestro Parque | Empresas GASCO',
    breadTitle: 'Nuestro Parque',
    layout: Layout,
    component: NuestroParque,
  },
  {
    path: '/noticias',
    title: 'Noticias | Empresas GASCO',
    breadTitle: 'Noticias',
    layout: Layout,
    component: Noticias,
  },
  { 
    path: '/noticias/:slug', 
    title: 'Noticia Detalle',
    layout: Layout,
    breadTitle: 'Noticias',
    component: NoticiaRouteHandler, 
  },
  {
    path: '/page2',
    title: title,
    breadTitle: 'Crear ' + breadTitle,
    layout: Layout, // Aquí va el Layout Standar para la app
    component: Page2, // Aquí va el component de la
  }
];

export default routesPages;

